export interface CentComUser {
  username: string;
  isAdmin: boolean;
}

interface UserEventBase {
  user: CentComUser;
  url: string;
  sessionId: string;
}

export interface NavigationEvent extends UserEventBase {
  args: {
    from_url: string;
  };
}
export interface ClickEvent extends UserEventBase {
  args: {
    x: number;
    y: number;
  };
}
export interface ActionEvent extends UserEventBase {
  args: {
    action: string;
  };
}
export type UserEvent = NavigationEvent | ClickEvent | ActionEvent;

export enum AccessLevel {
  User,
  SuperUser,
  Admin,
  Developer,
}
